// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  overflow-y: hidden !important;
}

.amy-top-nav {
  display: initial !important;
}

@media only screen and (max-width: 899px) {
  .form-width {
    width: inherit !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/main/webapp/app/components/ui/blog-list/blog-list-view.scss"],"names":[],"mappings":"AAAA;EACE,6BAAA;AACF;;AAEA;EACE,2BAAA;AACF;;AAEA;EACE;IACE,yBAAA;EACF;AACF","sourcesContent":["body {\n  overflow-y: hidden !important;\n}\n\n.amy-top-nav {\n  display: initial !important;\n}\n\n@media only screen and (max-width: 899px) {\n  .form-width {\n    width: inherit !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
